
import UserCardContent from '@/components/UserCardContent';
import styles from './index.module.scss';
import {USERINFO_TOOLTIP_CARD_TYPE} from '@/interface';
import {useCallback} from 'react';

interface IUserInfoCard extends Partial<User> {
    isShowAddPermission: boolean;
    isShowCoinDocList: boolean;
    isDimission: boolean;
    onGetPermission?: () => void;
    docUrl?: string;
}

export const UserInfoCard = ({
    isShowAddPermission,
    isShowCoinDocList,
    onGetPermission,
    isDimission,
    docUrl,
    ...user
}: IUserInfoCard) => {

    const noOnJobCont = isDimission ? '（已离职）' : '';
    const userName = user.nickname ? `${user.nickname}${noOnJobCont}` : '';

    const handleClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    }, []);

    return (user.canOpenSession ?
        <div className={styles.wrapper} onClick={handleClick}>
            <UserCardContent
                cardType={USERINFO_TOOLTIP_CARD_TYPE.editor}
                {...user}
                userGuid={user.userGuid}
                nickname={userName}
                avatar={user.avatar || ''}
                isShowAddPermission={isShowAddPermission}
                isShowCoinDocList={isShowCoinDocList}
                isShowAvatar
                onAddPermission={onGetPermission}
                docUrl={docUrl}
                isExternal={user?.external}
            />
        </div> : null);
};
